import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChannelsUnreadCountQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ChannelsUnreadCountQuery = { __typename?: 'RootQueryType', fetchChannelsUnreadCount: Array<{ __typename?: 'ChannelUnreadCount', channelId: string, channelDatabaseId: any, unreadCount: number }> };


export const ChannelsUnreadCountDocument = gql`
    query channelsUnreadCount($ids: [ID!]) {
  fetchChannelsUnreadCount(channelIds: $ids) {
    channelId
    channelDatabaseId
    unreadCount
  }
}
    `;

/**
 * __useChannelsUnreadCountQuery__
 *
 * To run a query within a React component, call `useChannelsUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsUnreadCountQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChannelsUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<ChannelsUnreadCountQuery, ChannelsUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelsUnreadCountQuery, ChannelsUnreadCountQueryVariables>(ChannelsUnreadCountDocument, options);
      }
export function useChannelsUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelsUnreadCountQuery, ChannelsUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelsUnreadCountQuery, ChannelsUnreadCountQueryVariables>(ChannelsUnreadCountDocument, options);
        }
export type ChannelsUnreadCountQueryHookResult = ReturnType<typeof useChannelsUnreadCountQuery>;
export type ChannelsUnreadCountLazyQueryHookResult = ReturnType<typeof useChannelsUnreadCountLazyQuery>;
export type ChannelsUnreadCountQueryResult = Apollo.QueryResult<ChannelsUnreadCountQuery, ChannelsUnreadCountQueryVariables>;
export function refetchChannelsUnreadCountQuery(variables?: ChannelsUnreadCountQueryVariables) {
      return { query: ChannelsUnreadCountDocument, variables: variables }
    }